<template>

    <v-form
            ref="modifyForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
      
      <v-card>
        
        <v-card-title>
          {{ srcShift ? srcShift.name : 'Add Shift' }}
        </v-card-title>
        
        <v-card-text>
          
          <v-text-field
            label="Shift Name"
            v-model="shift.name"
            :rules="[validationRules.required]"
          />
          
          <v-menu
              ref="startTimeMenu"
              v-model="showShiftStartMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="shiftTime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  label="Shift Start"
                  :value="shiftTime"
                  :rules="[validationRules.required]"
                  v-bind="attrs"
                  v-on="on"
                  readonly
              />
            </template>
            <v-time-picker
                v-if="showShiftStartMenu"
                v-model="shiftTime"
                full-width
                @click:minute="$refs.startTimeMenu.save(shiftTime)"
            ></v-time-picker>
          </v-menu>
          
          <v-text-field
              label="Minimum hours"
              :messages="['Minimum allowed hours for this shift, *All shifts without a clock out will be set to this value']"
              v-model.number="shift.minHours"
              type="number"
              :rules="[validationRules.required]"
          />
          
          <v-text-field
              label="Maximum hours"
              :messages="['Maximum allowed hours for this shift.']"
              v-model.number="shift.maxHours"
              type="number"
              :rules="[validationRules.required]"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="removeShift" :disabled="loading" v-if="shift.id">Remove Shift</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="resetShift; $emit('done')" :disabled="loading">Cancel</v-btn>
          <v-btn color="secondary" @click="done" :disabled="loading">Save Changes</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>


</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {validationRules} from "../../../core/codeFunctions";
import Divider from "../../General/Divider";

export default {
    components: {Divider},
    props: {
        srcShift: Object,
    },
    data() {
        return {
          validationRules: validationRules,
          loading: false,
          shift: {
              id: null,
              name: null,
              shiftStartHour: null,
              shiftStartMinute: null,
              maxHours: null,
              minHours: null,
              removed: false,
            },
          showShiftStartMenu: false
        }
    },
    watch: {
        srcShift: {
            deep: true,
            immediate: true,
            handler(val) {
              this.resetShift()
            }
        },
    },
    methods: {
      ...mapActions(['upsert']),
        async done() {
            try {
              this.loading = true
              if (!this.$refs.modifyForm.validate())
                  return false
              const updatedShift = await this.$newReq('POST', 'shifts/upsert', this.shift)
              Object.assign(this.shift, updatedShift)
              this.upsert({shifts: [this.shift]})
              this.$emit('done')
            } catch (e) {
              console.log(e)
              this.$snack.netWorkError()
            } finally {
              this.loading = false
            }
        },
      
      removeShift() {
        this.shift.removed = true
        this.done()
      },
      
      resetShift() {
        if (this.$refs.modifyForm)
          this.$refs.modifyForm.resetValidation()
        this.shift = JSON.parse(JSON.stringify(this.srcShift || {
          id: null,
          name: null,
          shiftStartHour: null,
          shiftStartMinute: null,
          maxHours: null,
          minHours: null,
          removed: false,
        }))
      }
    },
    computed: {
        ...mapGetters(['users', 'farms']),
      shiftTime: {
        get() {
          return (this.shift.shiftStartHour ?? 0).toString().padStart(2, '0') + ':' + (this.shift.shiftStartMinute ?? 0).toString().padStart(2, '0')
        },
        set(val) {
          this.shift.shiftStartHour = parseInt(val?.split(':')?.at(0) || 0)
          this.shift.shiftStartMinute = parseInt(val?.split(':')?.at(1) || 0)
        }
      },
    },
}
</script>

<style scoped>

</style>